import { useContext } from 'react';
import { DataAccessContext } from '@chargify/data-access';
import { useServices } from './useServices';
import { useInterpret } from '@xstate/react';
import { threeDsMachine } from '../machines/';
import { UpdateSubscriptionEvent } from '../machines/threeDs/types';

type Props = {
  subscriptionId: number;
  catalogId: number;
  onSuccess: () => void;
};
export const useThreeDs = ({ subscriptionId, catalogId, onSuccess }: Props) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useServices();
  return useInterpret(threeDsMachine, {
    services: {
      getSubscriptionDetails: () => {
        return dataAccess.getSubscriptionDetails(subscriptionId);
      },
    },
    actions: {
      updateSubscriptions: (context, event: UpdateSubscriptionEvent) => {
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          subscriptionId,
          catalogId,
          ...event.data,
          status: 'active',
        });
        onSuccess();
      },
    },
  });
};
